import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm0 21.42A9.42 9.42 0 1 1 21.42 12 9.44 9.44 0 0 1 12 21.42Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 7.62a4.38 4.38 0 1 0 0 8.76 4.38 4.38 0 1 0 0-8.76z"
})), 'RecordCircle');